export default "__VITE_ASSET__6143bfc7__"